import { render, staticRenderFns } from "./dvtManagement.vue?vue&type=template&id=f0e39cea&scoped=true&"
import script from "./dvtManagement.vue?vue&type=script&lang=js&"
export * from "./dvtManagement.vue?vue&type=script&lang=js&"
import style0 from "./dvtManagement.vue?vue&type=style&index=0&id=f0e39cea&prod&lang=scss&scoped=true&"
import style1 from "./dvtManagement.vue?vue&type=style&index=1&id=f0e39cea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e39cea",
  null
  
)

export default component.exports